import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query'
import { APIEndpoints } from '../constants/api-endpoints'
import { QueryKeys } from './_query_keys'
import { HttpRequest } from '../services/_http'

export type WebhookInstrumentRecord = {
  id: string
  platform: string
  event: string
  referenceId: string
  orderId: string
  requestDatetime: string | null
  responseDatetime: string | null
  payload: string
}

export const useWebhookInstrument = (
  searchOptions?: Record<string, unknown>,
  options?: UseQueryOptions
): UseQueryResult<any> =>
  useQuery({
    queryKey: [QueryKeys.WEBHOOK_INSTRUMENT, searchOptions],
    queryFn: () =>
      HttpRequest({
        url: APIEndpoints.WebhookInstrument,
        params: searchOptions,
        method: 'GET',
      }),
    refetchOnWindowFocus: false,
    cacheTime: 0,
    ...options,
  })
